export { default } from './isMuiElement';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/isMuiElement/index.js
// module id = 443
// module chunks = 25